import { IconButton } from "@mui/material"
import { X } from "../icons/x"

export const VirtualVisit = ({ setCurrent, setIframe, tmpFloorUnit }) => {
    return (
        <>
            <IconButton
                onClick={() => setCurrent({ main: "plans", sub: tmpFloorUnit })}
                sx={{
                    position: "absolute",
                    top: 15,
                    right: 15,
                    backgroundColor: "var(--blue)",
                    color: "var(--gold)",
                    borderRadius: 0,
                    width: 42,
                    height: 42,
                    zIndex: "25",

                    "&:hover": {
                        backgroundColor: "var(--gold)",
                        color: "var(--white)"
                    },
                }}
            >
                <X width={15} height={15} color="inherit" />
            </IconButton>
            <iframe onLoad={(e) => setIframe(e.target)} className="absolute z-[20] border-0 w-full h-full" src="./app/" />
        </>
    )
}